export const PAGE_LIMIT = 100;


// WEBPACK FOOTER //
// ./src/scenes/BidderError/config.js